import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useAuth } from '../../../common/hooks/useAuth';
import { useSzafir } from '../../../common/hooks/useSzafir';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { SignatureStatus } from '../../../common/spdCore/validation/schemas';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { SigningInProgressModal } from '../Szafir/SigningInProgressModal';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const CardSignLink = (props: { cardId: string }) => {
  const auth = useAuth();
  const szafir = useSzafir();
  const spd = useSpdCore();
  const [signStatus, setSignStatus] = useState<string>('');
  const [signingInProgress, setSigningInProgress] = useState<boolean>(false);

  spd.savedPdfs
    .getSignatureStatusForCard(props.cardId)
    .then(result => {
      setSignStatus(result.status);
    })
    .catch(err => {
      console.log('Błąd pobierania informacji o podpisie dokumentu:', err);
    });

  const handleClick = async () => {
    if (!auth.userProfile?.pin) {
      alert('Brak zdefiniowanego PINu. Przejdź i zdefiniuj PIN.');
      return;
    }
    setSigningInProgress(true);
    await signSaveAndSend();
  };

  const signSaveAndSend = async () => {
    spd.szafir
      .getTaskListForCard(props.cardId)
      .then(async taskList => {
        await szafir.signDocument(
          taskList,
          auth.userProfile?.pin || '',
          props.cardId,
          '',
          false,
          saveSignedPdf,
          signedFailed,
        );
      })
      .catch(async response => {
        const errors = await responseErrors(response as ResponseError);
        alert('Błąd pobierania listy TaskList dla karty :\n ' + errors);
        setSigningInProgress(false);
      });
  };

  const saveSignedPdf = async (result: Buffer | null) => {
    await spd.savedPdfs
      .savePdfFileForCard({
        entityId: props.cardId,
        file: result,
        english: false,
      })
      .then(() => {
        setSignStatus(SignatureStatus.Signed);
        setSigningInProgress(false);
        openSignedDocument(result);
      })
      .catch(async response => {
        const errors = await responseErrors(response as ResponseError);
        alert('Błąd zapisu PDF do bazy danych:\n ' + errors);
        setSigningInProgress(false);
      });
  };

  const signedFailed = (error: string) => {
    alert('Błąd:\n' + error);
    setSigningInProgress(false);
  };

  const openSignedDocument = (pdfData: Buffer | null) => {
    if (!pdfData) {
      return;
    }
    const blob = new Blob([new Uint8Array(pdfData)], {
      type: 'application/pdf',
    });
    const blobURL = URL.createObjectURL(blob);
    window.open(blobURL);
  };

  if (signingInProgress) {
    return <SigningInProgressModal />;
  }

  return (
    <div className="text-center">
      {signStatus === SignatureStatus.ToSign && (
        <OverlayTrigger
          overlay={<Tooltip style={{ position: 'fixed' }}>Podpisz</Tooltip>}
        >
          <Button
            onClick={e => {
              e.stopPropagation();
              void handleClick();
            }}
            variant="btn-info"
          >
            <Icon.PencilSquare className="icon-red" />
          </Button>
        </OverlayTrigger>
      )}
      {signStatus === SignatureStatus.Signed && (
        <OverlayTrigger
          overlay={<Tooltip style={{ position: 'fixed' }}>Podpisane</Tooltip>}
        >
          <Icon.CheckSquare className="icon-green mt-2" />
        </OverlayTrigger>
      )}
    </div>
  );
};
